import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { SuccessIcon, RemoveIcon } from 'foundations-assets';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Text } from 'foundations-components/components/Text';
import TwoFactorTokenExpired from './TwoFactorTokenExpired';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class TwoFactorRecoverySupportForm extends Component {
  constructor(...args) {
    super(...args);
    this.renderRecoveryButton = () => {
      const {
        isRecovering,
        onSubmit,
        recoveryAttempted,
        recoverySent
      } = this.props;
      return /*#__PURE__*/_jsx(LoadingButton, {
        block: true,
        use: "primary",
        type: "submit",
        disabled: !isRecovering && recoveryAttempted,
        resultIcon: !recoveryAttempted || recoverySent ? SuccessIcon : RemoveIcon,
        onClick: onSubmit,
        loading: isRecovering,
        children: I18n.text('login.twoFactor.recoverySupport.form.recoverButton')
      });
    };
    this.renderAlerts = () => {
      const {
        isRecoveryEmailInErrorState,
        recoveryNeedsSupport
      } = this.props;
      if (isRecoveryEmailInErrorState) {
        if (recoveryNeedsSupport) {
          return /*#__PURE__*/_jsx(Alert, {
            type: "danger",
            children: I18n.text('login.twoFactor.recovery.error.needsSupport')
          });
        }
        return /*#__PURE__*/_jsx(Alert, {
          type: "danger",
          children: I18n.text('login.twoFactor.recovery.error.errorText')
        });
      }
      return null;
    };
    this.renderForm = () => {
      const email = this.props.email || 'your email';
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoverySupport.form.description"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.twoFactor.recoverySupport.form.descriptionMore",
            options: {
              email
            }
          })
        }), this.renderAlerts(), this.renderRecoveryButton()]
      });
    };
    this.renderSuccess = () => {
      const email = this.props.email || 'your email';
      return /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "login.twoFactor.recoverySupport.success.emailed",
            options: {
              email
            }
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoverySupport.success.questions"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "login.twoFactor.recoverySupport.success.submitted"
          })
        })]
      });
    };
  }
  render() {
    const {
      recoveryAttempted,
      recoveryExpired,
      recoverySent
    } = this.props;
    let content;
    if (recoveryAttempted && recoveryExpired) {
      content = /*#__PURE__*/_jsx(TwoFactorTokenExpired, {});
    } else if (!recoveryAttempted || !recoverySent) {
      content = this.renderForm();
    } else {
      content = this.renderSuccess();
    }
    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Text, {
          textAlign: "center",
          as: "h1",
          children: I18n.text('login.twoFactor.recoverySupport.header')
        }), content]
      })
    });
  }
}
TwoFactorRecoverySupportForm.propTypes = {
  email: PropTypes.string.isRequired,
  isRecovering: PropTypes.bool.isRequired,
  recoveryAttempted: PropTypes.bool.isRequired,
  recoveryExpired: PropTypes.bool.isRequired,
  recoverySent: PropTypes.bool.isRequired,
  isRecoveryEmailInErrorState: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  recoveryNeedsSupport: PropTypes.bool.isRequired
};